import { IS_WORK_DESKTOP_NURTURE_BANNER_ENABLED } from '@/features/flags/legacy-flags';

/** Remote kill-switch for the Work routines → desktop nurture banner (AGE-1455). */
export const useIsWorkDesktopNurtureBannerEnabled = (): boolean => {
  return IS_WORK_DESKTOP_NURTURE_BANNER_ENABLED() ?? false;
};
